module.exports = __webpack_public_path__ + "img/teachee-logo.c665cf37.svg";